var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('drawer',{attrs:{"sidebar":_vm.sidebar},on:{"toggleSidebar":_vm.toggleSidebar}}),_c('Header',{staticClass:"header-dark",attrs:{"darkClass":{ menuItem: 'newspark-dark-menu-items' }},on:{"toggleSidebar":_vm.toggleSidebar}}),_vm._t("default"),_c('footer-dark'),_c('back-to-top')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }